<template>
    <div
        :class="onHome ? 'topic onHome' : 'topic'"
        :key="`topic-${topic.id}-${myTopics}`"
        :style="`z-index: 11; background-color: ${topic.color || '#edeae9'}; background-repeat: repeat-x; `"
        @click="onClick"
    >
        <!-- background-image:url('${topic.data ? topic.data.imageUrl : ''}'); background-size: 1500px 100px; background-position: -${0 * 240}px bottom;  -->
        <!-- <img :src="topic.data.imageUrl"> -->
        <h3>
            <span>{{ topic.name }}</span>
        </h3>
    </div>
</template>

<script>
import utils from '../js/utils';

export default {
    props: ['topic', 'onHome'],
    store: ['api', 'user', 'myTopics', 'progress', 'onboardingCompleted'],
    data () {
        return {};
    },
    methods: {
        onClick: function () {
            // onboarding skips overview
            if (this.topic.id === 58) {
                return this.$f7router.view.router.navigate(`/courses/223`);
            }
            let variant = parseFloat(localStore.getItem(`experiment-015_course-nav`));
            // skip overview if stated
            if (this.myTopics.indexOf(this.topic.id) > -1 && !variant) {
                // find last used course in topic
                let found = 0;
                for (let i = 0; i < this.progress.length; i++) {
                    const element = this.progress[i];
                    if (element.type === 'unit' && element.topicId === this.topic.id) {
                        found = element.courseId;
                    }
                }
                if (found) {
                    return this.$f7router.view.router.navigate(`/courses/${found}`);
                }
            }

            this.$f7router.view.router.navigate(`/topics/${this.topic.id}`);
        },
        goToInPopup: function (url) {
            if (this.disabled && !window.localStore.getItem('adminUnlockAll')) {
                return this.disabledCoach();
            }
            if (this.unit.hasVersions) {
                for (let i = 0; i < this.unit.versions.length; i++) {
                    const v = this.unit.versions[i];
                    if (!v.published) continue;
                    if (v.isVersionOf) {
                        let validUnit = utils.checkTraits(this.myTraits, v);
                        if (validUnit && this.unit.type === 'question') {
                            url = `/comments/${v.id}${this.home ? '?home=1' : ''}`;
                        } else if (validUnit) {
                            url = `/units/${v.id}${this.home ? '?home=1' : ''}`;
                        }
                    }
                }
            }
            f7.views['popup'].router.navigate(url, {
                animate: false,
                clearPreviousHistory: true,
                ignoreCache: true
            });
            if (!pgap) window.history.pushState(null, "", '/web' + url);
            setTimeout(() => {
                f7.popup.get('#popup').open();
            }, 550);
        },
        disabledCoach: function () {
            f7.toast
                .create({
                    text: `Oops... You need to finish the content earlier in your feed to access this unit!`,
                    position: 'center',
                    closeTimeout: 2000
                })
                .open();
        },
        renderDesc: function (desc) {
            return desc.length < 80 ? desc : desc.substring(0, 80) + '...';
        },
        isNew: function () {
            var fortnightAway = new Date(Date.now() - 12096e5);
            if ((new Date(this.unit.createdAt).getTime() - fortnightAway.getTime()) > 0) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style lang="less" scoped>
@import '../css/colors.less';
.topic {
    img {
        height: 120px;
        position: absolute;
        top: -15px;
        left: -20px;
        opacity: 0.7;
    }
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    width: 100%;
    min-width: 240px;
    max-width: 350px;
    display: inline-block;
    height: 90px;
    background-image: url('../img/1.4.0/goalwave.svg');
    background-position: bottom right;
    background-repeat: repeat-x;
    background-size: 220px 17px;
    transition: all 0.3 ease;
    backdrop-filter: blur(20px);
    //border: 2px solid transparent;
    h3 {
        height: 120px;
        text-align: left;
        margin-left: 0px;
        line-height: 70px;
        font-family: Editor-Bold;
        font-style: normal;
        font-size: 17px;
        letter-spacing: -0.1px;
        line-height: 55px;
        color: #fff;
        padding: 0px 5px 0;
        margin: 10px 0px 17px 0px;
        span {
            display: inline-block;
            vertical-align: middle;
            line-height: 21px;
            margin-left: 30px;
        }
    }
    &.onHome {
        height: 120px;
        margin-right: 20px;
        min-width: 120px;
        max-width: 140px;
        h3 {
            text-align: center;
            margin-left: 0px;
            line-height: 70px;
            span {
                margin-left: 0px;
            }
        }
    }
    &.selected {
        background: rgba(255, 255, 255, 1);
        //border: 2px solid #749592;
        img {
            opacity: 1;
        }
    }
}
@media only screen and (min-width: 600px) {
    .topic {
        margin-right: 10px;
    }
}
</style>
